import { AddPeopleToContentTypes } from "../../../../../enums";
import { type AppDispatch, type RootState } from "../../../../Application/globaltypes/redux";
import { getContentAssignmentModalFilterOptions as assessmentFilterOptions } from "../../../../Library/Assessments/state/thunks/assessmentFiltersThunk";
import { getContentAssignmentEmbeddedVideosFilterOptions as embeddedVideosFilterOptions } from "../../../../Library/EmbeddedVideos/state/thunks/EmbeddedVideosFiltersThunk";
import { resetAppliedFilter as eventResetFilter } from "../../../../Library/Events/state/slices/eventFilterSlice";
import { getFilterOptions as eventGetFilterOptions } from "../../../../Library/Events/state/thunks/eventFiltersThunk";
import { getContentAssignmentModalFilterOptions as flowFilterOptions } from "../../../../Library/Flows/state/thunks/flowFiltersThunk";
import { getContentAssignmentPdfFilterOptions as pdfFilterOptions } from "../../../../Library/Pdfs/state/thunks/pdfFiltersThunk";
import { getContentAssignmentSurveyFilterOptions } from "../../../../Library/Surveys/state/thunks/surveyFiltersThunk";
import { getContentAssignmentModalFilterOptions as videoFilterOptions } from "../../../../Library/Videos/state/thunks/videoFiltersThunk";
import { getContentAssignmentModalFilterOptions as linkFilterOptions } from "features/Library/ExternalLinks/state/thunks/externalLinkQueriesThunk";

import { contentContextSelector } from "../../../state/slices/addToContentSlice";
import { resetAppliedFilter } from "../slices/contentAssignmentsFiltersSlice";

/* istanbul ignore next */
export const fetchContentAssignmentsFilterOptions = () => (dispatch: AppDispatch, getState: () => RootState) => {
  const map = {
    [AddPeopleToContentTypes.Flows]: flowFilterOptions,
    [AddPeopleToContentTypes.Uploaded]: videoFilterOptions,
    [AddPeopleToContentTypes.Events]: eventGetFilterOptions,
    [AddPeopleToContentTypes.Surveys]: getContentAssignmentSurveyFilterOptions,
    [AddPeopleToContentTypes.Assessments]: assessmentFilterOptions,
    [AddPeopleToContentTypes.PDFs]: pdfFilterOptions,
    [AddPeopleToContentTypes.Embedded]: embeddedVideosFilterOptions,
    [AddPeopleToContentTypes.Links]: linkFilterOptions,
  };

  dispatch(map[contentContextSelector(getState())]());
};

/* istanbul ignore next */
export const resetContentAssignmentsFilterOptions = () => (dispatch: AppDispatch, getState: () => RootState) => {
  const map = {
    [AddPeopleToContentTypes.Flows]: resetAppliedFilter,
    [AddPeopleToContentTypes.Uploaded]: resetAppliedFilter,
    [AddPeopleToContentTypes.Events]: eventResetFilter,
    [AddPeopleToContentTypes.Surveys]: resetAppliedFilter,
    [AddPeopleToContentTypes.Assessments]: resetAppliedFilter,
    [AddPeopleToContentTypes.PDFs]: resetAppliedFilter,
    [AddPeopleToContentTypes.Embedded]: resetAppliedFilter,
    [AddPeopleToContentTypes.Links]: resetAppliedFilter,
  };

  dispatch(map[contentContextSelector(getState())]());
};
